module.exports = __webpack_public_path__ + "static/media/country_is.a2a796d6.webp";